export default __webpack_public_path__ + "static/media/1752813.62efd98e.png";